import React, { memo } from "react";

function CheckBoxInput({
  label,
  id,
  name,
  disabled = false,
  required,
  handleClick,
  errorMessage,
  checked = false,
  className,
}) {
  return (
    <div className="form-check d-flex align-items-center mt-2 mb-2">
      <input
        className="form-check-input me-2"
        type="checkbox"
        value=""
        checked={checked}
        id={id}
        disabled={disabled}
        name={name}
        onClick={handleClick}
        style={
          errorMessage && errorMessage[name]
            ? { borderColor: "#c8605e" }
            : {}
        }
      />
      <label
        className={`form-check-label fs-5 form-label-custom-visible ${className}`}
        htmlFor={id}
      >
        {label} {required && <span className="mandatory">*</span>}
      </label>
      <div className="text-danger-new fw-700 fs-6  mt-1">
        {errorMessage && errorMessage[name] && errorMessage[name]}
      </div>
    </div>
  );
}

export default memo(CheckBoxInput);
